import type { AccountGradingRecording } from "@repo/app-types/entities/teammatePerformanceSummary";
import { useContext } from "react";
import { AudioPlayerContext } from "../../components/audioPlayer/context.js";
import { useAudioCurrentTime } from "../../components/audioPlayer/useAudioCurrentTime.js";

export function useCallAudioPosition(
  recordings: readonly AccountGradingRecording[],
) {
  const audioPlayer = useContext(AudioPlayerContext);
  const audioCurrentTime = useAudioCurrentTime(audioPlayer.nativeAudio);
  const selectedRecordingId = recordings.find(
    (recording) => recording.id === audioPlayer.currentSourceKey,
  )?.id;
  const hasAudioPosition =
    audioPlayer.hasRequestedPosition ||
    audioCurrentTime > 0 ||
    (audioPlayer.nativeAudio !== null &&
      (!audioPlayer.nativeAudio.paused ||
        audioPlayer.nativeAudio.played.length > 0));
  const audioPosition =
    selectedRecordingId && hasAudioPosition
      ? { recordingId: selectedRecordingId, timestamp: audioCurrentTime * 1000 }
      : undefined;

  return { selectedRecordingId, audioPosition };
}
